import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {
    getAuthHeader, getLocalStorageItem,
    getPathAndQueryParams,
    objectLang,
    refreshMoney,
    setErrorWindow, setGlobalMoneyObject, setLocalStorageItem,
    setMoneyMonthDetailPath,
    setMoneyPathBack,
    setPathBack
} from "../functions"
import config from '../config.json'
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {MainMoneyClass} from "../components/MainMoneyClass"

export const MainMoneyPage = () => {
    setLocalStorageItem('page', 'MainMoneyPage')
    setMoneyPathBack(getPathAndQueryParams())
    setMoneyMonthDetailPath(getPathAndQueryParams())
    const auth = useContext(AuthContext)
    const {request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [money, setMoney] = useState(null)
    const [loading, setLoading] = useState(false)

    const lang = objectLang().language

    const getData = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/money/get`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.isNew) {
                setLocalStorageItem('isNewMoney', 'true')
                window.location.replace(`/${l}/money/add-card`)
            }
            if (data.status !== 200) {
                setAllowed(false)
                setLoading(false)
                setDataModal(setErrorWindow('', data.code, data.message, '', `replaceTo /${l}/`))
            } else {
                if (data.money.settings.cards.length < 1) {
                    setLocalStorageItem('isNewMoney', 'true')
                }
                setMoney(data['money'])
                setLocalStorageItem('dataMoney', data['money'])
                setPathBack(getPathAndQueryParams())
                setLoading(false)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [request, auth])

    useEffect( () => {
        const dataMoney = getLocalStorageItem('dataMoney')
        if (dataMoney) {
            setMoney(dataMoney)
            const getMoney = async () => {
                const m = await refreshMoney(auth, request).then()
                if (m) {
                    setGlobalMoneyObject(m)
                    setMoney(m)
                }
            }
            getMoney().then()
        } else {
            setLoading(true)
            getData().then()
        }
    }, [getData, auth, request])

    if (!allowed) {
        return (
            <ModalWin data={dataModal}/>
        )
    }

    if (loading) {
        return (
            <>
                <LoaderClass/>
            </>
        )
    }

    return (
        <>
            <MainMoneyClass
                lang={lang}
                money={money}
            />
        </>
    )
}